// sessionDialogTrigger.js
let showDialogCallback = null;

export function registerSessionDialogCallback(callback) {
  showDialogCallback = callback;
}

export function triggerSessionDialog() {
  if (showDialogCallback) {
    showDialogCallback();
  }
}

let isRefreshing = false;
let failedQueue = [];

export function setIsRefreshing(val) {
  isRefreshing = val;
}

export function getIsRefreshing() {
  return isRefreshing;
}

export function addToFailedQueue(promiseHandler) {
  failedQueue.push(promiseHandler);
}

export function processQueue(error, token = null) {
  failedQueue.forEach(({ resolve, reject }) => {
    if (error) reject(error);
    else resolve(token);
  });
  failedQueue = [];
}
